export default __webpack_public_path__ + "static/media/icon3.52f1f7d2.png";